/**
 * checkArrayIncludes
 * 
 * Ищет вхождения элементов массива array2 в массиве array1. 
 * Если есть хотя бы одно вхождение - возвращает true. 
 * 
 * @param {Array} array1 - массив, элементы которого ищём в array2
 * @param {Array} array2 - массив, в котором ищем
 * @returns {Boolean}
 */
export default function checkArrayIncludes(array1 = [], array2 = []) {

    return array1.some(item => array2.includes(item)) ? true : false
}